import { EMULATOR, GLEAP_API_KEY } from '../core/constants/env'

const keysConfiguration = {
  emulator: EMULATOR,
  gleapApiKey: GLEAP_API_KEY
}

export default keysConfiguration
